<template>
  <v-layout row>
    <v-flex xs6
            class="mr-5">
      <v-select v-model="tagSelected"
                :items="internalTags"
                item-text="code"
                item-value="code"
                return-object
                :label="$t('global.teletag')"
                prepend-icon="local_offer"
                required></v-select>
    </v-flex>
    <v-flex xs6
            class="ml-5">
      <v-text-field v-model="plateSelected"
                    :rules="plateRules"
                    :disabled="!canEditPlate"
                    prepend-icon="mdi mdi-car"
                    :label="$t('global.plate')"></v-text-field>
    </v-flex>
  </v-layout>
</template>
<script>
import _ from 'lodash';

export default {
  name: 'ReservationTagSelection',
  props: {
    tags: {
      type: Array,
      required: true
    },
    tagCodeSelected: {
      type: String
    },
    canEditPlate: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    plateRules() {
      return [v => /^[a-zA-Z0-9-]+$/.test(v) || this.$i18n.t('plate.validation.valid.characters')];
    }
  },
  watch: {
    tagSelected(value) {
      this.plateSelected = value.plate;
      this.$emit('on-tag-selected', { tag: value });
    },
    plateSelected(value) {
      this.internalTags = _.cloneDeep(this.tags);
      this.$emit('on-plate-changed', { plate: value });
    },
    tags(value) {
      if (value.length > 0 && this.internalTags.length === 0) {
        this.internalTags = _.cloneDeep(value);
        if (typeof this.tagCodeSelected !== 'undefined') {
          let tempTagSelected = _.find(this.internalTags, it => {
            return it.code === this.tagCodeSelected;
          });

          this.tagSelected = tempTagSelected;
        } else {
          this.tagSelected = this.internalTags[0];
        }
        this.plateSelected = this.tagSelected.plate;
      }
    }
  },
  data() {
    return {
      plateSelected: '',
      tagSelected: { plate: '' },
      internalTags: []
    };
  }
};
</script>

